<ion-header>
    <app-header [backRoute]="['home-multi']" [middleIcon]="false"
                [headerTitle]="type === 'tdm' ? 'Technical Decision Maker Simulation' : 'Executive Decision Maker Simulation'"></app-header>
</ion-header>
<ion-content [fullscreen]="step === 'sim'">
    <div *ngIf="showPoints">
        <div class="points-notification">
            {{ "__SIMULATOR_POINTS_NOTIFICATION_PREFIX__" | translate }}
            {{ points }}
            {{ "__SIMULATOR_POINTS_NOTIFICATION_SUFFIX__" | translate }}
        </div>
    </div>
    <div *ngIf="loading" class="background-wrap page-width-and-shadow">
        <div class="content-wrap-inner">
            <ion-skeleton-text style="width:50%;height:2.5rem;margin-bottom: 2.5rem;" animated></ion-skeleton-text>

            <ion-skeleton-text *ngFor="let i of [1,2,3,4]" style="width:100%;height:1.5rem;margin-bottom: 0.5rem;" animated></ion-skeleton-text>
            <br/>
            <ion-skeleton-text *ngFor="let i of [1,2,3,4,5]" style="width:100%;height:1.5rem;margin-bottom: 0.5rem;" animated></ion-skeleton-text>
            <br/>
            <ion-skeleton-text *ngFor="let i of [1,2,3]" style="width:100%;height:1.5rem;margin-bottom: 0.5rem;" animated></ion-skeleton-text>
            <br/>
            <ion-skeleton-text style="width:6em;height:6em;margin: 0 auto" animated></ion-skeleton-text>
        </div>
    </div>
    <div *ngIf="step === 'background' && !loading" class="background-wrap page-width-and-shadow">
        <div *ngIf="type === 'tdm'" class="content-wrap-inner">
            <div class="title my-color-blue">{{ "__SIMULATOR__TDM_PERSON__" | translate }}</div>
            <p>{{ "__SIMULATOR__TDM_INTRO_1__" | translate }}</p>
            <p><b>{{ "__SIMULATOR_URBAN_BANK__" | translate }}</b>{{ "__SIMULATOR_TDM_INTRO_2__" | translate }}</p>
            <p><b>{{ "__SIMULATOR_JAY__" | translate }}</b>{{ "__SIMULATOR_TDM_INTRO_3__" | translate }}</p>
            <p>{{ "__SIMULATOR_TDM_INTRO_4__" | translate }}</p>
            <p>{{ "__SIMULATOR_TDM_INTRO_5__" | translate }}</p>
            <p>{{ "__SIMULATOR_TDM_INTRO_6__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_AUDIO_QUALITY_HINT_1__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_MICROPHONE_HINT__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_NOISE_HINT__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_ONE_ATTEMPT_WARNING__" | translate }}</p>

            <div *ngIf="!result.tdm_score || result.tdm_score < 700" class="run-sim">
                <img  src="assets/img/press.svg" alt="press"
                     class="touch-eff-radius" (click)="runGame()">
            </div>
            <div *ngIf="result.tdm_score >= 700" class="sim-result">
                <p *ngIf="result.tdm_result === 'EXIT'" class="sim-result-warning">{{ "__SIMULATOR_TDM_INCOMPLETE__" | translate }} <br /><br /><a (click)="goToHelpDesk()">{{ "__SIMULATOR_OPEN_HELPDESK__" | translate }}</a></p>
                <div *ngIf="result.tdm_result !== 'EXIT'" class="sim-result-title">{{ "__SIMULATOR_TDM_SCORE_LABEL__" | translate }} <span>{{result.tdm_score}}</span></div>
                <button *ngIf="result.tdm_result !== 'EXIT'" class="sim-result-link big"
                        (click)="goToSimulatorEDM()">{{ "__SIMULATOR_TDM_NEXT_LEVEL__" | translate }}
                    <img class="arrow" src="assets/img/blue-forward1.svg">
                </button>
            </div>
<!--            <button (click)="displayPoints(123)">Points</button>-->
        </div>

        <div *ngIf="type === 'edm' && !loading" class="content-wrap-inner">
            <div class="title my-color-blue">{{ "__SIMULATOR_EDM_PERSON__" | translate }}</div>
            <p>{{ "__SIMULATOR_EDM_INTRO_1__" | translate }} <b>{{ "__SIMULATOR_EDM_PERSON__" | translate }}</b>, {{ "__SIMULATOR_EDM_INTRO_2__" | translate }}</p>
            <p>{{ "__SIMULATOR_EDM_INTRO_3__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_AUDIO_QUALITY_HINT_2__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_MICROPHONE_HINT__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_NOISE_HINT__" | translate }}</p>
            <p class="text-warning">{{ "__SIMULATOR_ONE_ATTEMPT_WARNING__" | translate }}</p>

            <div *ngIf="!result.tdm_score || result.tdm_score < 700" class="sim-result">
                <div class="sim-result-title">{{ "__SIMULATOR_TDM_FIRST_WARNING__" | translate }}</div>
                <button class="sim-result-link big" (click)="goToSimulatorTDM()">
                    {{ "__SIMULATOR_TDM_BACK_BUTTON__" | translate }}
                    <img class="arrow" src="assets/img/blue-forward1.svg">
                </button>
            </div>
            <div *ngIf="result.tdm_score >= 700 && result.tdm_result !== 'EXIT' && (!result.edm_score || result.edm_score < 700)" class="run-sim">
                <img  src="assets/img/press.svg" alt="press"
                      class="touch-eff-radius" (click)="runGame()">
            </div>
            <div *ngIf="result.tdm_score >= 700 && result.tdm_result === 'EXIT' || result.edm_score > 700 && result.edm_result === 'EXIT'" class="sim-result">
                <p class="sim-result-warning">{{ "__SIMULATOR_EDM_INCOMPLETE__" | translate }} <br /><br /><a (click)="goToHelpDesk()">Open Helpdesk - Submit a ticket</a></p>
            </div>
            <div *ngIf="result.edm_score >= 700" class="sim-result">
                <p *ngIf="result.edm_result === 'EXIT'"class="sim-result-warning">{{ "__SIMULATOR_EDM_INCOMPLETE__" | translate }}<br /><br /><a (click)="goToHelpDesk()">Open Helpdesk - Submit a ticket</a></p>
                <div *ngIf="result.edm_result !== 'EXIT'" class="sim-result-title">{{ "__SIMULATOR_EDM_SCORE_LABEL__" | translate }} <span>{{result.edm_score}}</span></div>
                <button *ngIf="result.edm_result !== 'EXIT'" class="sim-result-link big" (click)="goToLeaderboard()">
                    {{ "__SIMULATOR_EDM_LEADERBOARD_BUTTON__" | translate }}
                    <img class="arrow" src="assets/img/blue-forward1.svg">
                </button>
            </div>
        </div>

    </div>
    <div *ngIf="step === 'sim'" class="sim-wrap page-width-and-shadow">
        <iframe *ngIf="!!simSrc" [srcdoc]="simSrc" allow="camera https://alchemist-client.speakeasy-client.pages.dev;microphone https://alchemist-client.speakeasy-client.pages.dev" credentialless>
        </iframe>
    </div>

    <div *ngIf="step === 'results' && !loading" class="background-wrap page-width-and-shadow">
        <div class="content-wrap-inner">
            <div class="title my-color-blue">{{ "__SIMULATOR_CONGRATULATIONS_TITLE__" | translate }}</div>
            <div class="sim-result" *ngIf="type === 'tdm'">
                <p>{{ "__SIMULATOR_TDM_FINISH_TEXT_1__" | translate }}</p>
                <p><b>{{ "__SIMULATOR_YOUR_SCORED__" | translate }} {{result.tdm_score}}</b></p>
                <p>{{ "__SIMULATOR_TDM_UNLOCK_TEXT__" | translate }}</p>
                <br/>
                <button class="sim-result-link big" (click)="goToSimulatorEDM()">
                    {{ "__SIMULATOR_TDM_START_EDM_BUTTON__" | translate }}
                    <img class="arrow" src="assets/img/blue-forward1.svg">
                </button>
            </div>
            <div class="sim-result" *ngIf="type === 'edm'">
                <p>{{ "__SIMULATOR_EDM_FINISH_TEXT_1__" | translate }}</p>
                <p><b>{{ "__SIMULATOR_YOUR_SCORED__" | translate }} {{result.edm_score}}</b></p>
                <br />
                <button class="sim-result-link big" (click)="goToLeaderboard()">
                    {{ "__SIMULATOR_EDM_LEADERBOARD_LINK__" | translate }}
                    <img class="arrow" src="assets/img/blue-forward1.svg">
                </button>
            </div>
        </div>
    </div>
</ion-content>
